import { render } from "./NoahAdmin.vue?vue&type=template&id=80770808&scoped=true"
import script from "./NoahAdmin.vue?vue&type=script&lang=js"
export * from "./NoahAdmin.vue?vue&type=script&lang=js"

import "./NoahAdmin.vue?vue&type=style&index=0&id=80770808&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80770808"]])

export default __exports__